module.exports = __webpack_public_path__ + "static/img/home24.dcb7006.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home24.png
// module id = QzYQ
// module chunks = 13